import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6229a6b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bubbles",
  width: "60",
  height: "25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 121 60"
}
const _hoisted_2 = {
  r: "13",
  class: "bubble3"
}
const _hoisted_3 = ["dur"]
const _hoisted_4 = {
  r: "17",
  class: "bubble2"
}
const _hoisted_5 = ["dur"]
const _hoisted_6 = {
  r: "20",
  class: "bubble1"
}
const _hoisted_7 = ["dur"]
const _hoisted_8 = {
  key: 1,
  class: "bar",
  width: "57",
  height: "6",
  viewBox: "0 0 57 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "barBg",
  d: "M3.16699 2.9939H53.167",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "barAnim",
  d: "M3.16699 2.9939H53.167",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "infinity",
  width: "60",
  height: "25",
  viewBox: "0 0 121 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

import { computed, ComputedRef } from 'vue';

type AnimationType = 'bubbles' | 'bar' | 'infinity';

interface Props {
  animationType?: AnimationType;
  duration?: number;
}
const path: string =
  `M61.4504 25.9577L43.815 8.32233C34.0205 -1.44078 18.1404 -1.44078 8.3459 8.32233
  C-1.44863 18.0854 -1.44863 33.9146 8.3459 43.6777C18.1404 53.4408 34.0205 53.4408 
  43.815 43.6777L61.4504 26L79.185 8.32233C88.9795 -1.44078 104.86 -1.44078 114.654 
  8.32233C124.449 18.0854 124.449 33.9146 114.654 43.6777C104.86 53.4408 88.9795 53.4408 79.185 43.6777
  L61.5073 26`;


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingAnimation',
  props: {
    animationType: { default: 'bar' },
    duration: { default: 3 }
  },
  setup(__props: any) {

const props = __props;

const cssVars: ComputedRef<Record<string, string | undefined>> = computed(() => {
  return {
    '--duration': `${props.duration}s`,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "loadingAnimation",
    style: _normalizeStyle(cssVars.value)
  }, [
    (_ctx.animationType === 'bubbles')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
          _createElementVNode("circle", _hoisted_2, [
            _createElementVNode("animateMotion", {
              dur: `${_ctx.duration * 0.64}s`,
              repeatCount: "indefinite",
              path: path
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("circle", _hoisted_4, [
            _createElementVNode("animateMotion", {
              dur: `${_ctx.duration * 0.8}s`,
              repeatCount: "indefinite",
              path: path
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("circle", _hoisted_6, [
            _createElementVNode("animateMotion", {
              dur: `${_ctx.duration}s`,
              repeatCount: "indefinite",
              path: path
            }, null, 8, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.animationType === 'bar')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_11))
      : _createCommentVNode("", true),
    (_ctx.animationType === 'infinity')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [
          _createElementVNode("path", {
            class: "infinityBg",
            d: path,
            "stroke-linecap": "round"
          }),
          _createElementVNode("path", {
            class: "infinityAnim",
            d: path,
            "stroke-linecap": "square"
          })
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})